module.exports = __webpack_public_path__ + "img/move10.bc0fb655.jpg";